import React from "react"
import { Drawer, RaisedButton, Tabs, Tab, CircularProgress, Paper } from "material-ui"
import autobind from "class-autobind"
import _ from "lodash"
import AppStateStore from "../../stores/AppStateStore"
import AddPaymentDialog from "./AddPaymentDialog"
import AccountInfoForm from "../../pages/account/AccountInfoForm"
import AccountBillingForm from "../../pages/account/AccountBillingForm"
import AccountStore from "../../stores/AccountStore"
import * as api from "../../api"
import AuthenticationStore from "../../stores/AuthenticationStore"
import strings from "../../localization/strings"
import AccountSubscription from "./AccountSubscription"
import AccountBillingInvoicesTable from "./AccountBillingInvoicesTable"
import { EPlanType, IStripeSetupIntent, IStripePaymentMethod, IStripeInvoice } from "../../models"
import * as accountActions from "../../actions/AccountActions"

interface IProps {
    open: boolean
    handleClose(): void
}
interface IState {
    open: boolean
    showAddPayment: boolean
    tabActive: string
    stripeElements,
    paymentElement,
    stripeObject,
    clientKey: string
    paymentMethods: IStripePaymentMethod[]
    loadingPaymentMethods: boolean
    loadingInvoices: boolean
    invoices: IStripeInvoice[]
}

export default class AccountBillingDrawerContent extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        let urlSearch = new URLSearchParams(window.location.search)
        super(props)
        this.state = {
            open: false,
            tabActive: "account_history",
            showAddPayment: false,
            paymentElement: null,
            stripeObject: null,
            clientKey: null,
            stripeElements: null,
            paymentMethods: [],
            loadingPaymentMethods: true,
            loadingInvoices: false,
            invoices: []
        }
        autobind(this)
    }

    getCCIcon(type) {
        switch (type) {
            case "visa": {
                return <i className="fa fa-cc-visa" />
            }
            case "mastercard": {
                return <i className="fa fa-cc-mastercard" />
            }
            case "amex": {
                return <i className="fa fa-cc-amex" />
            }
            case "discover": {
                return <i className="fa fa-cc-discover" />
            }
            case "jcb": {
                return <i className="fa fa-cc-jcb" />
            }
            case "diners": {
                return <i className="fa fa-cc-diners-club" />
            }
        }
    }

    componentDidMount() {
        // this.getData()
        // AccountStore.on("accounts_config", this.getData)
    }

    componentWillUnmount() {
      //  AccountStore.removeListener("accounts_config", this.getData)
    }

    getData() {
        const accountsConfig = AccountStore.getAccountsConfig()
        if (!accountsConfig) return
        this.setState({ stripeObject: Stripe(accountsConfig.StripePublishableKey) }, () =>
            api.setupPaymentIntent(AuthenticationStore.getCookieAccountId()).then(res => {
                AccountStore.getAllowSTRIPEPaymentMethod() &&
                    this.getPaymentMethods()
                this.getInvoices()
                var elements = this.state.stripeObject.elements({
                    clientSecret: (res.data as IStripeSetupIntent).ClientSecret,
                })
                this.setState({ paymentElement: elements.create('payment'), clientKey: (res.data as IStripeSetupIntent).ClientSecret, stripeElements: elements })
            })
        )
    }

    getPaymentMethods(cb = null) {
        api.getPaymentMethods(AuthenticationStore.getCookieAccountId()).then(res => {
            this.setState({ paymentMethods: res.data, loadingPaymentMethods: false })
            cb && typeof cb === "function" && cb()
        })
    }

    getInvoices() {
        this.setState({ loadingInvoices: true }, () => {
            api.getInvoices(AuthenticationStore.getCookieAccountId()).then(res => {
                this.setState({ invoices: res.data, loadingInvoices: false })
            })
        })
    }

    addPaymentMethod() {
        let elements = this.state.stripeElements
        this.state.stripeObject.confirmSetup({
            elements,
            confirmParams: {
                // Return URL where the customer should be redirected after the SetupIntent is confirmed.
                return_url: window.location.href + "?billing_details=true&tabs=account_payment_method",
            },
        })
            .then(result => result.error && result.error.message &&
                AppStateStore.setAlertDialogContent({
                    content: result.error.message
                })
            )
    }

    deletePaymentInfo(paymentMethodId) {
        this.setState({ loadingPaymentMethods: true }, () => {
            api.removePaymentMethod(paymentMethodId).then(res =>
                this.getPaymentMethods(() => accountActions.getAccount(AuthenticationStore.getCookieAccountId()))
            )
        })
    }

    render() {
        const accountStats = AccountStore.getCurrentAccountSettings().AccountStats
        return (
            <Drawer
                open={this.props.open}
                openSecondary
                width={1200}
                docked={false}
                overlayStyle={{ zIndex: 1500 }}
                containerStyle={{ zIndex: 1500, overflow: "unset", opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
                onRequestChange={this.props.handleClose}
            >
                <div style={{ padding: 35, backgroundColor: AppStateStore.getDrawerHeaderColor(), textAlign: "center", color: "#ffffff", fontWeight: "normal", fontSize: 25 }}>
                    {strings.Account_Billing_Details}
                    <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={this.props.handleClose} />
                </div>
                <Tabs
                    value={this.state.tabActive}
                    onChange={tabActive => this.setState({ tabActive })}
                >
                    
                    {false && AccountStore.getCurrentAccount().BillingInfo.PlanType !== EPlanType.Enterprise &&
                        <Tab label={strings.AccountSubscriptionOverview} value="account_info">
                            <div style={{ padding: 20, overflow: "auto", height: "calc(100vh - 178px)" }}>
                                <AccountSubscription account={AccountStore.getCurrentAccount()} />
                            </div>
                        </Tab>
                    }
                    <Tab label={strings.AccountBillingHistory} value="account_history">
                        <div style={{ padding: 50, overflow: "auto", height: "calc(100vh - 238px)" }}>
                            <div style={{ width: "100%" }}>
                                <AccountBillingForm
                                    billingData={accountStats}
                                    calculateBillingByDevice={AccountStore.getCurrentAccountSettings().CalculateBillingByDevice}
                                />
                            </div>
                            <div style={{ width: "100%" }}>
                                <h3>{strings.RecentInvoices}</h3>
                                <AccountBillingInvoicesTable loadingInvoices={this.state.loadingInvoices} invoices={this.state.invoices} />
                            </div>
                        </div>
                    </Tab>
                    <Tab label={strings.AccountBillingContact} value="account_billing_contact">
                        <div style={{ padding: 50, overflow: "auto", height: "calc(100vh - 238px)" }}>
                            <AccountInfoForm />
                        </div>
                    </Tab>
                    { false && AccountStore.getAllowSTRIPEPaymentMethod() &&
                        <Tab label={strings.AccountPaymentMethod} value="account_payment_method">
                            <div style={{ padding: 50, overflow: "auto", height: "calc(100vh - 238px)" }}>
                                {this.state.paymentMethods.length > 0 &&
                                    <Paper style={{ padding: 20 }}>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ width: "50%" }}>
                                                <div style={{ fontSize: 16, fontWeight: "bold" }}>{this.state.paymentMethods[0].BillingDetails.Name}</div>
                                                <div style={{ fontSize: 12, fontWeight: "normal" }}>
                                                    {this.getCCIcon(this.state.paymentMethods[0].Card.Brand)} {this.state.paymentMethods[0].Card.Brand} •••• {this.state.paymentMethods[0].Card.Last4} {this.state.paymentMethods[0].Card.ExpMonth}/{this.state.paymentMethods[0].Card.ExpYear}
                                                </div>
                                                <div style={{ fontSize: 12 }}>
                                                    {strings.Future_payments_will_use_this_card}
                                                </div>
                                            </div>
                                            <div style={{ width: "50%", textAlign: "right" }}>
                                                <RaisedButton
                                                    data-intercom-target={"Paywall-Drawer-Btn-Upgrade"}
                                                    backgroundColor="#1181F2"
                                                    labelColor="white"
                                                    label={strings.RemoveCard}
                                                    style={{ width: "30%", marginTop: 15 }}
                                                    onTouchTap={() => {
                                                        AppStateStore.setConfirmDialogContent({
                                                            content: strings.Are_You_Sure_You_Want_To_Remove_This_Payment_Method,
                                                            confirm: () => this.deletePaymentInfo(this.state.paymentMethods[0].Id)
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </Paper>
                                }
                                {this.state.loadingPaymentMethods &&
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <div id="card-element">
                                            <CircularProgress size={30} />
                                        </div>
                                    </div>
                                }
                                {!this.state.loadingPaymentMethods && this.state.paymentMethods.length === 0 &&
                                    <RaisedButton
                                        backgroundColor="white"
                                        labelColor="#1181F2"
                                        label={strings.AddPaymentMethod}
                                        style={{ width: "30%", marginTop: 15, border: "2px solid #1181F2" }}
                                        onTouchTap={() => {
                                            const accountSettings = AccountStore.getCurrentAccount().AccountSettings;
                                            (accountSettings.ContactName && accountSettings.ContactEmail) ?
                                                this.setState({ showAddPayment: true }, () => {
                                                    this.state.paymentElement.mount('#card-element')
                                                }) :
                                                AppStateStore.setAlertDialogContent({
                                                    content: strings.Please_input_the_Billing_Contact_before_add_payment_method,
                                                    handleCloseCallBack: () => this.setState({ tabActive: "account_billing_contact" })
                                                })
                                        }}
                                    />
                                }
                            </div>
                        </Tab>
                    }
                </Tabs>
                <AddPaymentDialog
                    open={this.state.showAddPayment}
                    addPaymentMethod={this.addPaymentMethod}
                    onClose={() => this.setState({ showAddPayment: false })}
                />
            </Drawer>
        )
    }
}